module.exports = __webpack_public_path__ + "img/2.ff1cd489.png";